var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.ready
    ? _c(
        "div",
        { staticClass: "details" },
        [
          _c("AppHeader", {
            attrs: {
              title: _vm.tier.name,
              items: _vm.menu,
              backButton: {
                container: "app",
                page: "Tiers",
              },
            },
          }),
          _vm._v(" "),
          _c(
            "v-container",
            {
              staticClass: "pl-3 pr-3 pb-3",
              attrs: { fluid: "", "grid-list-xl": "" },
            },
            [
              _vm.$route.params.type === "informations"
                ? _c("Informations", { attrs: { tier: _vm.tier } })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }